import { useState } from "react"
import { auth } from "../firebase/config"
import { signInWithEmailAndPassword } from "@firebase/auth"
import { useAuthContext } from "../hooks/useAuthContext"
import { useCollection } from '../hooks/useCollection';
import { useDispatch } from 'react-redux';
import { setId, setIsMaster } from '../context/companySlice'
import { setBranch } from '../context/adminProgramSlice';

export const useLogin = () => {
    const [error, setError] = useState(null)

    const { dispatch } = useAuthContext()
    const { data: companies } = useCollection('/Companies')
    const companyDispatch = useDispatch();


    function isCompanyAdmin(user) {
        let foundCompany = companies && companies.filter(c => c.adminEmail === user)
        if (foundCompany.length > 0) {
            const companyId = foundCompany[0].id
            const isMaster = foundCompany[0].isMaster
            let branch = (isMaster || companyId === '') ? 'Master' : companyId
            companyDispatch(setId(companyId));
            companyDispatch(setIsMaster(isMaster));
            companyDispatch(setBranch(branch))
            return true
        }
        return false
    }

    const login = (email, password) => {
        setError(null)
        if (isCompanyAdmin(email)) {
            signInWithEmailAndPassword(auth, email, password)
                .then((res) => {
                    dispatch({ type: 'LOGIN', payload: res.user })
                })
                .catch((err) => {
                    setError(err.message)
                })
        } else {
            setError("Kan ikke logge inn. Sjekk brukernavn og passord.")
        }
    }

    return { error, login }

}